"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAndroidVariantCommand = void 0;
const AbstractUpdateVariantCommand_1 = require("./AbstractUpdateVariantCommand");
class UpdateAndroidVariantCommand extends AbstractUpdateVariantCommand_1.AbstractUpdateVariantCommand {
    constructor(api, appId, variantId) {
        super(api, appId, variantId, 'android');
        this.withGoogleKey = (googleKey) => {
            this.def.googleKey = googleKey;
            return this;
        };
        this.withProjectNumber = (projectNumber) => {
            this.def.projectNumber = projectNumber;
            return this;
        };
    }
}
exports.UpdateAndroidVariantCommand = UpdateAndroidVariantCommand;
//# sourceMappingURL=UpdateAndroidVariantCommand.js.map